import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RegularDateFormatMMMdyyyy } from '@anecdotes/design-system/constants';
import { LocalDatePipe } from '@anecdotes/design-system/pipes';
import { isDatesEqual } from '@anecdotes/utils';

const millisecondsInDay = 86400000;
const limitDaysInMonthToSupport = 30;

@Component({
  selector: 'app-time-ago-date-view',
  templateUrl: './time-ago-date-view.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeAgoDateViewComponent {
  dateFormat = RegularDateFormatMMMdyyyy;

  @Input()
  descriptionTranslationKey: string;

  @Input()
  date: string | Date;

  amount: number;

  get tooltipDate(): string {
    return this.localDatePipe.transform(
      (this.date instanceof Date) ? this.date.toISOString() : this.date,
      this.dateFormat,
      undefined
    );
  }

  constructor(private localDatePipe: LocalDatePipe) {}

  resolveDisplayedDateMessage(): string {
    const difference = Math.ceil(this.getDifferenceBetweenDates());

    if (isDatesEqual(new Date(this.date))) {
      return this.buildTranslationKey('today');
    }
    if (difference > 0 && difference < limitDaysInMonthToSupport) {
      this.amount = difference;
      return this.buildTranslationKey('day');
    }
    if (difference >= limitDaysInMonthToSupport) {
      this.amount = Math.floor(difference / limitDaysInMonthToSupport);
      return this.buildTranslationKey('month');
    }
  }

  buildTranslationKey(relativeKey: string): string {
    return `evidences.evidenceCollectionDate.${relativeKey}`;
  }

  private getDifferenceBetweenDates(): number {
    return (new Date().getTime() - this.getDate().getTime()) / millisecondsInDay;
  }

  private getDate(): Date {
    if (typeof this.date === 'string') {
      return new Date(this.date);
    }
    return this.date;
  }
}
